import home from './src/home.vue'
import businesses from './src/BusinessManager/businesses.vue' //商户列表
import businessinfo from './src/BusinessManager/businessinfo.vue' //商户信息
import businesstypes from './src/BusinessManager/businesstypes.vue' //商户类型列表信息
import businesstypeinfo from './src/BusinessManager/businesstypeinfo.vue' //商户类型详情信息
import BusinessQueryOrder from './src/BusinessOrder/BusinessOrderQuery.vue' //商户订单查询详情信息
import BusinessBalance from './src/BusinessBalance/BusinessBalance.vue' //商户提现详情信息
import BusinessBalanceInfo from './src/BusinessBalance/BusinessBalanceInfo.vue' //商户提现详情信息
import BusinessApply from './src/BusinessApply/BusinessApply.vue' //商户申请提现列表信息
import BusinessApplyInfo from './src/BusinessApply/BusinessApplyInfo.vue' //商户申请提现详情信息
import childbusinesses from './src/BusinessManager/childbusinesses.vue' //子商户列表
import childbusinessinfo from './src/BusinessManager/childbusinessinfo.vue' //子商户信息
import QRCodePage from './src/BusinessManager/QRCode.vue'//二维码


let views = {
    home,
    businesses,
    businessinfo,
    businesstypes,
    BusinessBalance,
    BusinessBalanceInfo,
    businesstypeinfo,
    BusinessQueryOrder,
    BusinessApply,
    BusinessApplyInfo,
    childbusinesses,
    childbusinessinfo,
    QRCodePage
};


export default views;

